import React, { useCallback } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { EntryPointContainer } from 'react-relay';
import { reportError } from '@atlaskit/report-error';
import { useEntryPointConfig } from '@atlassian/entry-point-config';
export function InternalEntryPointContainer(_ref) {
  var entryPointReference = _ref.entryPointReference,
    errorFallback = _ref.errorFallback,
    onErrorLocal = _ref.onError,
    fallback = _ref.fallback,
    id = _ref.id,
    placeholderName = _ref.placeholderName,
    runtimeProps = _ref.runtimeProps;
  var _useEntryPointConfig = useEntryPointConfig(),
    PlaceholderComponent = _useEntryPointConfig.PlaceholderComponent,
    UFOSegmentComponent = _useEntryPointConfig.UFOSegmentComponent;
  var onError = useCallback(function (error, errorInfo) {
    onErrorLocal === null || onErrorLocal === void 0 || onErrorLocal({
      error: error,
      errorInfo: errorInfo
    });
    reportError({
      error: error,
      errorInfo: errorInfo,
      interactionId: id
    });
  }, [onErrorLocal, id]);
  var FallbackComponent = useCallback(function (_ref2) {
    var error = _ref2.error;
    return errorFallback ? errorFallback({
      error: error
    }) : null;
  }, [errorFallback]);
  return /*#__PURE__*/React.createElement(UFOSegmentComponent, {
    name: id
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    FallbackComponent: FallbackComponent,
    onError: onError
  }, /*#__PURE__*/React.createElement(PlaceholderComponent, {
    name: placeholderName !== null && placeholderName !== void 0 ? placeholderName : 'internal-internal-entry-point-container',
    fallback: fallback
  }, /*#__PURE__*/React.createElement(EntryPointContainer, {
    entryPointReference: entryPointReference,
    props: runtimeProps
  }))));
}